import * as constants from './constants';

const initialProfile = {
  token: '',
  email: '',
  role: '',
};

export const initialState = {
  loading: false,
  profile: initialProfile,
  registrationInfo: {},
  registrationCompleted: false,
  error: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.LOGIN:
    case constants.LOGIN_SUCCESS:
    case constants.LOGIN_FAIL:
    case constants.LOGOUT_SUCCESS:
    case constants.LOGOUT_FAIL:
    case constants.FETCH_PROFILE:
    case constants.FETCH_PROFILE_SUCCESS:
    case constants.FETCH_PROFILE_FAIL:
    case constants.START_REGISTRATION:
    case constants.COMPLETE_REGISTRATION_SUCCESS:
    case constants.COMPLETE_REGISTRATION_FAIL:
    case constants.FETCH_REGISTRATION_INFO_SUCCESS:
    case constants.FETCH_REGISTRATION_INFO_FAIL:
    case constants.RESTORE_PASSWORD_START_SUCCESS:
    case constants.RESTORE_PASSWORD_START_FAIL:
    case constants.RESTORE_PASSWORD_END_SUCCESS:
    case constants.RESTORE_PASSWORD_END_FAIL:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default authReducer;
